/**
 * @generated SignedSource<<5d73766a0c395fadbf10a67e9bc7e982>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TimeRegistrationModalUpdate_viewer$data = {
  readonly actualPersonId: string | null;
  readonly timeRegistration: {
    readonly id: string;
    readonly taskId: string | null;
    readonly projectId: string | null;
    readonly idleTimeId: string | null;
    readonly minutesRegistered: number | null;
    readonly billableMinutesRegistered: number | null;
    readonly notes: string | null;
    readonly year: number | null;
    readonly month: number | null;
    readonly day: number | null;
    readonly person: {
      readonly id: string;
    } | null;
    readonly harvestTask: {
      readonly id: string;
    } | null;
    readonly role: {
      readonly id: string;
      readonly name: string | null;
    } | null;
    readonly task: {
      readonly id: string;
      readonly jiraId: string | null;
      readonly project: {
        readonly id: string;
      } | null;
    } | null;
  } | null;
  readonly " $fragmentType": "TimeRegistrationModalUpdate_viewer";
};
export type TimeRegistrationModalUpdate_viewer$key = {
  readonly " $data"?: TimeRegistrationModalUpdate_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"TimeRegistrationModalUpdate_viewer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  (v0/*: any*/)
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "timeRegistrationId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "TimeRegistrationModalUpdate_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "actualPersonId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "id",
          "variableName": "timeRegistrationId"
        }
      ],
      "concreteType": "TimeRegType",
      "kind": "LinkedField",
      "name": "timeRegistration",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "taskId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "projectId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "idleTimeId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "minutesRegistered",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "billableMinutesRegistered",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "notes",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "year",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "month",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "day",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Person",
          "kind": "LinkedField",
          "name": "person",
          "plural": false,
          "selections": (v1/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "HarvestTaskType",
          "kind": "LinkedField",
          "name": "harvestTask",
          "plural": false,
          "selections": (v1/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Role",
          "kind": "LinkedField",
          "name": "role",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Task",
          "kind": "LinkedField",
          "name": "task",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "jiraId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "ProjectType",
              "kind": "LinkedField",
              "name": "project",
              "plural": false,
              "selections": (v1/*: any*/),
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "009974a106b0aff1a2c36b6bcc61542e";

export default node;
